import { FcWithChildren } from "types/fcWithChildren";

export const LmBlock: FcWithChildren = ({ children }) => {
  return (
    <div className="lm__block lm__block-box">
      <div className="lm__block-box">{children}</div>
    </div>
  );
};
